/* eslint-disable */
import React,{useState} from 'react';
//css
import 'contents/assets/scss/page/teacher.scss';
//component
import PopRequestPoint from '../../mypage/_PopRequestPoint';
import Calendar from '../../../component/Inc/Calendar';
//image
function IncentiveDetail() {
  const [isOrderActive1, setIsOrderActive1] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <main className="com_container com_salary">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className='com_pg_tit icon menu12_8'>인센티브 명세서 <span className="bar"/><span className="point_txt">최교사103</span></h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalOpen(true)} className="com_btn orange s btn_plus">인센티브 지급</button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className='com_board_list__top'>
              <select className="select">
                <option value="이지수능 (본사)">이지수능 (본사)</option>
              </select>
            </div>
            <Calendar type="salary" />
            <hr className="com_divider" />
            <div className="salary_wrap">
              {/* 급여 명세서 */}
              <div className="receipt">
                <div className="detail_tit dot">3월 급여 명세서
                  <button className="com_btn black xs btn_refresh">최초값 복원</button>
                </div>
                <div className="scroll_wrap">
                  <table className='com_board_list type_row'>
                    <colgroup>
                      <col width="40%"/><col width="30%"/><col width="30%"/>
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>기본급</th>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <th>타임추가</th>
                        <td>12회</td>
                        <td></td>
                      </tr>
                      <tr>
                        <th>추가</th>
                        <td>12회</td>
                        <td></td>
                      </tr>
                      <tr>
                        <th>교사지목</th>
                        <td>4회</td>
                        <td></td>
                      </tr>
                      <tr>
                        <th>관리신규</th>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <th>소개</th>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <th>총 인센티브 지급액</th>
                        <td colSpan={2} className='td_point bold bg_col'>898,000</td>
                      </tr>
                    </tbody>
                  </table>

                  {/* 공제 수수료 */}
                  <div className="detail_tit">* 공제 수수료</div>
                  <table className='com_board_list type_row'>
                    <colgroup>
                      <col width="40%"/><col width="60%"/>
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>관리수수료 (10%)</th>
                        <td className='td_red'>78,150,000<button className="btn_edit"/></td>
                      </tr>
                      <tr>
                        <th>미수금 외</th>
                        <td className='td_red'>78,150,000<button className="btn_edit"/></td>
                      </tr>
                      <tr>
                        <th>관리 수수료지급액</th>
                        <td className='td_red bg_col'>78,150,000<button className="btn_edit"/></td>
                      </tr>
                      <tr>
                        <th>장기특별관리수수료</th>
                        <td className='td_red'><button className="btn_edit"/></td>
                      </tr>
                      <tr>
                        <th>우수관리특별수수료</th>
                        <td className='td_red'><button className="btn_edit"/></td>
                      </tr>
                      <tr>
                        <th>위험보전금</th>
                        <td className='td_red'><button className="btn_edit"/></td>
                      </tr>
                      <tr>
                        <th></th>
                        <td className='td_red'><button className="btn_edit"/></td>
                      </tr>
                      <tr>
                        <th>사업소득세(3%)</th>
                        <td className='td_red'><button className="btn_edit"/></td>
                      </tr>
                      <tr>
                        <th>사업주민세(0.3%)</th>
                        <td className='td_red'><button className="btn_edit"/></td>
                      </tr>
                      <tr>
                        <th>세금공제후지급액</th>
                        <td className='td_red'><button className="btn_edit"/></td>
                      </tr>
                      <tr>
                        <th>시책본인부담금</th>
                        <td className='td_red'><button className="btn_edit"/></td>
                      </tr>
                      <tr>
                        <th><input type='text'/></th>
                        <td><input type='text'/></td>
                      </tr>
                      <tr>
                        <th>산재보험</th>
                        <td className='td_red'></td>
                      </tr>
                      <tr>
                        <th>주차비</th>
                        <td className='td_red'></td>
                      </tr>
                      <tr>
                        <th>상조회비</th>
                        <td className='td_red'></td>
                      </tr>
                      <tr>
                        <th>선급금</th>
                        <td className='td_red'></td>
                      </tr>
                      <tr>
                        <th></th>
                        <td></td>
                      </tr>
                      {/* <tr>
                        <th>
                          <button className="btn_add_black"></button>
                          <button className="btn_minus_black"></button>
                        </th>
                        <td></td>
                      </tr> */}
                    </tbody>
                  </table>
                  {/* 총 지급액 */}
                  <table className='com_board_list type_row'>
                    <colgroup>
                      <col width="40%"/><col width="60%"/>
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>급여 총 지급액</th>
                        <td className='td_point bold'>64,568,000</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="com_btn_wrap center">
                  <button className="com_btn orange xs">인센티브 지급하기</button>
                </div>
              </div>
              
              {/* 수업 정산 승인 상세내역 */}
              <div className="detail">
                <div className="detail_tit dot">2월 수업 정산 승인 상세 내역
                  <button className="com_btn black xs btn_delete_orange">선택항목 삭제</button>
                </div>
                <table className='com_board_list'>
                  <colgroup>
                    <col width="5%"/><col width="6%"/>
                    <col width="6%"/><col width="6%"/>
                    <col width="6%"/><col width="6%"/>
                    <col width="6%"/><col width="6%"/>
                    <col width="6%"/><col width="6%"/>
                    <col width="6%"/><col width="6%"/>
                    <col width="6%"/><col width="9%"/><col width="9%"/>
                  </colgroup>
                  <thead>
                    <tr>
                      <th>선택</th><th>비고</th><th>학생명</th>
                      <th>과목</th><th>회차 / T</th><th>총 수업료</th>
                      <th>
                        <div className="sort"><button onClick={() => {setIsOrderActive1(!isOrderActive1)}} className={`arrow ${isOrderActive1 ? `active` : ``}`} /><span>최종 입금일</span>
                        </div>
                      </th>
                      <th>정산회차</th>
                      <th>입금한 금액</th><th>입금자</th>
                      <th>환불 사유</th><th>환불액</th>
                      <th>인센티브(%)</th><th>인센티브 지급액</th>
                      <th>최종 정산금액</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input type="checkbox" id="chk00" className="com_chk" />
                        <label htmlFor="chk00"></label>
                      </td>
                      <td className='td_point'>소개</td>
                      <td>김길동111</td>
                      <td>과탐</td>
                      <td>48회 / 2T</td>
                      <td>466,000</td>
                      <td>2022, 08, 25 11:30</td>
                      <td>16.5</td>
                      <td>1,000,000</td>
                      <td>홍길동</td>
                      <td className='td_red'>취소</td>
                      <td className='td_red'>-45,000</td>
                      <td>5%</td>
                      <td className='td_point'>45,000</td>
                      <td className='td_point'>6,565,656</td>
                    </tr>
                  </tbody>
                </table>

                <div className="com_btn_wrap">
                  <button className="com_btn black xs btn_print">인쇄하기</button>
                  <button className="com_btn black xs btn_down_orange">다운로드</button>
                </div>
              </div>
            </div>
          </section>
        </section>
      </div>
      <PopRequestPoint open={modalOpen} close={() => setModalOpen(false)} />
    </main>
  );
}

export default IncentiveDetail;
